import { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { login, logout } from "../common/api/auth";
import { AuthContext } from "../context/AuthContext";
import { useToast } from "../hooks/useToast";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const { setIsLoggedIn } = useContext(AuthContext);
  const toast = useToast();


  useEffect(() => {
    logout();

    const rememberedUser = localStorage.getItem("remembered_user");
    if (rememberedUser) {
      setUsername(rememberedUser);
      setRemember(true);
    }
  }, []);

  useEffect(() => {
    if (location.state?.username) {
      setUsername(location.state.username);
      setPassword("");
    }
  }, [location.state?.username]);

  const handleLogin = async (e) => {
    e.preventDefault();

    const trimmedUsername = username.trim();

    if (!trimmedUsername) {
      toast.error("Debes introducir un usuario válido.");
      return;
    }

    try {
      const result = await login(trimmedUsername, password);

      if (result?.needsPasswordReset) {
        if (remember) {
          localStorage.setItem("remembered_user", trimmedUsername);
        } else {
          localStorage.removeItem("remembered_user");
        }

        sessionStorage.setItem("pending_user", trimmedUsername);
        toast.info("Debes crear una nueva contraseña antes de continuar.");
        navigate("/set-password", { state: { username: trimmedUsername } });
        return;
      }

      if (result?.success) {
        sessionStorage.removeItem("pending_user");
        localStorage.setItem("current_user", trimmedUsername);
        setIsLoggedIn(true);

        if (remember) {
          localStorage.setItem("remembered_user", trimmedUsername);
        } else {
          localStorage.removeItem("remembered_user");
        }

        navigate("/home");
        return;
      }

      toast.error("Usuario o contraseña incorrectos.");
    } catch (error) {
      console.error("Error en el proceso de login:", error);
      toast.error("No se pudo iniciar sesión. Inténtalo nuevamente.");
    }
  };



  return (
    <section className="cuerpo_login">
      <form className="login" onSubmit={handleLogin}>
        <span className="logo">
          <img src="/logo.svg" alt="marca_agua_bigrid" />
        </span>

        <span className="titulo">Sign In</span>

        <div className="input-group">
          <label className="label" htmlFor="username">
            Usuario
          </label>
          <input
            className="input"
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="off"
          />

          <label className="label" htmlFor="password">
            Contraseña
          </label>
          <input
            className="input"
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
          />
        </div>

        <div className="checkbox">
          <input
            type="checkbox"
            id="remember"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          />
          <label htmlFor="remember">Recordar usuario.</label>
          {/*<a href="#">Forgot password?</a>*/}
        </div>
        <button className="boton_login" type="submit">
          Sign in
        </button>
      </form>
    </section>
  );
}
export default Login;
